// 로딩 상태를 표시하는 컴포넌트
export const LoadingSpinner = () => {
    return (
        <div className="parent-container">
            <div className="spinner" ></div>
        </div>
    );
};